(function($) {

	function update_summary($form = null){

		if( !($form instanceof jQuery ) ){
			$form = $(this).closest('form');
		}

		let url = $form.attr('action') + "&action=pos_return_summary",
			data = $form.serializeArray()

		// remove action to prevent collision in ajax
		data = data.filter((item) => item.name !== 'action');

		gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			show_loading: true,
			data: data
		})
	}
	function item_selected(e){

		let $input = $(this);

		let $item = $input.closest('.pos__returns_item');

		let $reasons = $item.find('.pos__returns-reasons');

		if($input.is(':checked')){
			$reasons.slideDown();
			$reasons.prop('disabled', false);
		}else{
			$reasons.slideUp();
			$reasons.prop('disabled', true);
		}
	}
	function collapse_reasons($item, text)
	{
		$item.find('.pos__returns__chosen-reason').text(text);
		$item.find('.pos__returns-chosen').slideDown();
		$item.find('.pos__returns-form').slideUp();
	}
	function expand_reasons()
	{
		let $item = $(this).closest('.pos__returns_item');
		$item.find('.pos__returns-chosen').slideUp();
		$item.find('.pos__returns-form').slideDown();
	}
	function reason_selected(e){

		let $input = $(this);

		let $item = $input.closest('.pos__returns_item');

		let $other_text = $item.find('.pos__returns__choose-textarea');

		if($input.is(':checked')){
			// show/hide other reason textarea
			if($input.val() === '0'){
				$other_text.show();
				$other_text.prop('disabled', false);
				$other_text.find('[name$="[reason_detail][0]"]').focus();
			}else{
				$other_text.hide();
				$other_text.prop('disabled', true);
				collapse_reasons($item, $input.siblings('.pos__returns__choose-text').text());
			}
		}
	}

	function change_qty() {

		let $this = $(this);

		let modifier = $this.data('change-qty');

		let $item = $this.closest('.pos__returns_item');
		let $input = $item.find('[name^="item["][name$="][quantity]"');

		let new_qty = Number($input.val()) + Number(modifier);
		if($input.is('[data-max]') && $input.data('max') < new_qty ){
			new_qty = $input.data('max');
		}
		if($input.is('[data-min]') && $input.data('min') > new_qty ){
			new_qty = $input.data('min');
		}

		if($input.val() != new_qty){
			$input.val(new_qty);
			// update displayed qty
			$item.find('[data-qty-display]').html(new_qty);
			$input.trigger('change');
		}
	}

	function quantity_changed() {

		let $this = $(this);

		let $item = $this.closest('.pos__returns_item');
		$item.find('[data-qty-display]').html($this.val());

		// update summary if item is selected
		if($item.find('[name^="item["][name$="][return]"]').is(':checked')){
			update_summary($item.closest('form'));
		}
	}
	function add_custom_reason() {
		let $item = $(this).closest('.pos__returns_item');
		let reason = $item.find('[name$="[reason_detail][0]"]').val();
		if(reason){
			collapse_reasons($item, reason);
		}
	}
	$('form.gp-ajax-form--pos_return_new, form.gp-ajax-form--pos_return_edit, form.gp-ajax-form--pos_return_manager')
		.on('change', '.update_summary', update_summary)
		.on('change', '[name^="item["][name$="][return]"]', item_selected) // item selection
		.on('change', '[name^="item["][name$="][reason]"]', reason_selected) // reason selection
		.on('click', '[data-change-qty]', change_qty) // qty button
		.on('change', '[name^="item["][name$="][quantity]"]', quantity_changed)
		.on('click', '.add_custom_reason', add_custom_reason)
		.on('click', '.pos__returns__chosen-change', expand_reasons)
})(jQuery);